export default function Table({ children, className = '' }) {
  return (
    <div className={`overflow-x-auto rounded-[10px] border border-[rgba(148,163,184,0.06)] ${className}`}>
      <table className="w-full text-sm">{children}</table>
    </div>
  );
}

export function THead({ children }) {
  return <thead className="bg-[rgba(148,163,184,0.02)] border-b border-[rgba(148,163,184,0.06)]">{children}</thead>;
}

export function TH({ children, className = '' }) {
  return (
    <th className={`px-4 py-3 text-left text-[10px] font-medium text-[#475569] uppercase tracking-wider ${className}`}>
      {children}
    </th>
  );
}

export function TBody({ children }) {
  return <tbody className="divide-y divide-[rgba(148,163,184,0.06)]">{children}</tbody>;
}

export function TR({ children, className = '', onClick }) {
  return (
    <tr className={`hover:bg-[rgba(148,163,184,0.02)] transition-colors ${onClick ? 'cursor-pointer' : ''} ${className}`} onClick={onClick}>
      {children}
    </tr>
  );
}

export function TD({ children, className = '' }) {
  return <td className={`px-4 py-3 text-[#94a3b8] text-[12.5px] ${className}`}>{children}</td>;
}

export function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between mt-4 px-2">
      <span className="text-[12px] text-[#475569]">Page {page} of {totalPages}</span>
      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="px-3 py-1.5 text-[12px] bg-[#0f1623] border border-[rgba(148,163,184,0.06)] text-[#94a3b8] rounded-lg disabled:opacity-40 hover:border-[rgba(148,163,184,0.10)] transition-colors"
        >
          Previous
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="px-3 py-1.5 text-[12px] bg-[#0f1623] border border-[rgba(148,163,184,0.06)] text-[#94a3b8] rounded-lg disabled:opacity-40 hover:border-[rgba(148,163,184,0.10)] transition-colors"
        >
          Next
        </button>
      </div>
    </div>
  );
}
